var map = {
	"./grade_1.png": "h4Jn",
	"./grade_10.png": "lqJX",
	"./grade_11.png": "dtc/",
	"./grade_12.png": "71wa",
	"./grade_13.png": "mXmb",
	"./grade_14.png": "esY9",
	"./grade_15.png": "6a9x",
	"./grade_16.png": "7/h6",
	"./grade_17.png": "1wgQ",
	"./grade_2.png": "yXXz",
	"./grade_3.png": "z6fD",
	"./grade_4.png": "p+pI",
	"./grade_5.png": "TSeB",
	"./grade_6.png": "EYio",
	"./grade_7.png": "Y1GV",
	"./grade_8.png": "ZSMZ",
	"./grade_9.png": "sXZp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q0Uu";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img ^\.\/grade_.*\.png$
// module id = q0Uu
// module chunks = 80